
//Iconos
import { LuArrowUpNarrowWide } from "react-icons/lu"

import { useLocation, useNavigate } from "react-router-dom"
import { listaEstadosActivoBusqueda } from "../../../app/constants/constants-selectores"
import { useForm } from "react-hook-form"
import { DataContext } from "../../../app/providers/DataContext"
import { useContext, useEffect, useState } from "react"
import { moduloDelete, moduloMostrar, moduloSubirNivel, modulosBuscar } from "../api/modulos.api"
import { obtenerLocalStorage } from "../../../shared/utils/funciones"
import Swal from 'sweetalert2';
import { IoMdAdd } from "react-icons/io"
import { BiSearch } from "react-icons/bi"
import { useMobileDetection } from "../../../shared/hooks/useMobileDetection"
import { CONST_KEY_USUARIO_AUTENTICADO } from "../../../app/constants/constanst-valores"
import { validarAutenticacion } from "../../auth"
import { CONST_CODIGO_MODULOS_AGREGAR, CONST_CODIGO_MODULOS_EDITAR, CONST_CODIGO_MODULOS_ELIMINAR, CONST_RUTA_MODULOS_AGREGAR, CONST_RUTA_MODULOS_EDITAR, CONST_RUTA_MODULOS_LISTAR, CONST_RUTA_SIN_ACCESO } from "../../../app/constants/constants-rutas-codigos"
import { rutasCodigosPrograma } from "../../../app/constants/constanst-arreglo-rutas-codigo"
import { useRefetchAlCerrarModal } from "../../../shared/hooks/useRefetchAlCerrarModal"
import { usuarioObtenerCompaniasYSucursales } from "../../usuarios"
// Tabla de resultados extraída a subcomponente presentacional.
import { ModulosTabla } from "../components/ModulosTabla";

export const Modulos = () => {

  const usuarioAutenticado = obtenerLocalStorage(CONST_KEY_USUARIO_AUTENTICADO);
  //Obtener la accion a partir de la url (agregar o editar)
  const location = useLocation();

  const arrayModulosSuperiores = location?.state?.arrayModulosSuperiores

  const { listaRutasDeAcceso } = useContext(DataContext)
  const [listaCompanias, setListaCompanias] = useState<any[]>([])

  const [codModuloSuperior, setCodModuloSuperior] = useState("")
  const [nombreModuloSuperior, setNombreModuloSuperior] = useState("")
  const [companiaDelModulo, setCompaniaDelModulo] = useState("")

  const [isLoading, setIsLoading] = useState(false)
  const [moduloSuperior] = useState(arrayModulosSuperiores || [0])

  const isMobile = useMobileDetection()

  //Estados para ver si mostrar o no los botones
  const [mostrarBotonAgregar, setMostrarBotonAgregar] = useState(false)
  const [mostrarBotonEditar, setMostrarBotonEditar] = useState(false)
  const [mostrarBotonEliminar, setMostrarBotonEliminar] = useState(false)

  const { register, handleSubmit, watch, setValue } = useForm<Record<string, any>>({
    defaultValues: {
      estado: "A",
    }
  });

  const {
    reset: resetOrdenar
  } = useForm({
    defaultValues: {
      modulosOrdenados: [{}]
    },
  })

  const [listaModulos, setListaModulos] = useState<any[]>([])
  const [buscar, setBuscar] = useState(false)

  const onSubmitBuscar = async (data) => {

    let modulosSuperiores = [...moduloSuperior];

    setIsLoading(true)
    const dataPOST = {
      CompCod: data?.compania,
      ModDesc: data?.modulo || "",
      Estado: data?.estado,
      Superior: modulosSuperiores.pop() || "",
      token: usuarioAutenticado?.token
    }

    const { modulos } = await modulosBuscar(dataPOST)

    const listaModulosOrdenados = modulos?.map((m) => ({
      codModulo: m?.ModCod,
    }))
    resetOrdenar({
      modulosOrdenados: listaModulosOrdenados
    })
    setListaModulos(modulos)
    setBuscar(true)
    setIsLoading(false)
  };

  const navigate = useNavigate()

  const moduloAgregar = async () => {

    const rutaNavegar = CONST_RUTA_MODULOS_AGREGAR
    const modulo = rutasCodigosPrograma.find(r => r.ruta === rutaNavegar)

    const validarAutenticado = await validarAutenticacion(usuarioAutenticado?.token, modulo?.codigo)

    let modulosSuperiores = [...moduloSuperior];

    if (validarAutenticado) {
      navigate(rutaNavegar, {
        state: {
          superior: { id: modulosSuperiores.pop() },
          codCompania: companiaDelModulo,
          arrayModulosSuperiores: moduloSuperior
        }
      })
    } else {
      navigate(CONST_RUTA_SIN_ACCESO)
    }

  }

  const moduloEditar = async (CodModulo) => {

    const rutaNavegar = CONST_RUTA_MODULOS_EDITAR
    const modulo = rutasCodigosPrograma.find(r => r.ruta === rutaNavegar)

    const validarAutenticado = await validarAutenticacion(usuarioAutenticado?.token, modulo?.codigo)

    if (validarAutenticado) {
      const dataPOST = {
        CodigoModulo: CodModulo,
        token: usuarioAutenticado?.token
      }
      const { modulo } = await moduloMostrar(dataPOST)

      navigate(rutaNavegar, {
        state: {
          superior: { id: codModuloSuperior, tipo: nombreModuloSuperior },
          modulo: modulo,
          arrayModulosSuperiores: moduloSuperior
        }
      })
    } else {
      navigate(CONST_RUTA_SIN_ACCESO)
    }

  }

  const modulosBuscarTodos = async () => {

    setIsLoading(true)
    let modulosSuperiores = [...moduloSuperior];

    const dataPOST = {
      CompCod: watch("compania") || listaCompanias?.[0]?.id || "",
      ModDesc: watch("modulo") || "",
      Estado: watch("estado"),
      Superior: modulosSuperiores.pop() /* || codModuloSuperior */,
      token: usuarioAutenticado?.token
    }

    const { modulos } = await modulosBuscar(dataPOST)

    const listaModulosOrdenados = modulos?.map(m => ({
      codModulo: m?.ModCod,
    }))
    resetOrdenar({
      modulosOrdenados: listaModulosOrdenados
    })
    setListaModulos(modulos)
    setIsLoading(false)

  }

  const moduloListarSubModulos = async (codModulo, nomModulo, codCompania) => {

    moduloSuperior.push(codModulo)
    setCodModuloSuperior(codModulo)
    setNombreModuloSuperior(nomModulo)
    setCompaniaDelModulo(codCompania)
    modulosBuscarTodos()
  }

  const moduloRetroceder = async () => {
    if (moduloSuperior.length > 1) {

      let modulosSuperiores = [...moduloSuperior]
      const dataPOST = {
        CompCod: watch("compania"),
        Estado: watch("estado"),
        Superior: modulosSuperiores.pop(),
        token: usuarioAutenticado?.token
      }

      const { modulos } = await moduloSubirNivel(dataPOST)
      moduloSuperior.pop()
      if (String(modulos?.[0]?.ModSup) === "0") {
        setCompaniaDelModulo("")
      }

      setListaModulos(modulos)
    }
  }

  const optionsEliminar = (modulo) => {
    return {
      title: `¿Estás seguro de eliminar al módulo: ${modulo}?`,
      icon: 'warning' as const,
      showCancelButton: true,
      cancelButtonColor: '#6c757d',
      confirmButtonColor: '#d33',
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
    }
  }

  const moduloEliminar = (codModulo, modulo) => {
    Swal.fire(optionsEliminar(modulo)).then(async (result) => {
      if (result.isConfirmed) {

        const dataPOST = {
          ModCod: codModulo,
          token: usuarioAutenticado?.token
        }
        const { status } = await moduloDelete(dataPOST)
        if (status === 1) {
          modulosBuscarTodos()
          Swal.fire(
            'Módulo eliminado',
            '',
            'success'
          )
        } else {
          Swal.fire(
            'Error al eliminar módulo',
            '',
            'success'
          )
        }

      }
    })

  }

  const obtenerCompaniasYSucursales = async () => {

    const dataPOST = {
      token: usuarioAutenticado?.token
    }

    const { companias, sucursales } = await usuarioObtenerCompaniasYSucursales(dataPOST)
    setListaCompanias(companias)
    setValue("compania", companias?.[0]?.id)

    return {
      companias,
      sucursales
    }
  }

  useEffect(() => {

    const encontradoRutaBotonAgregar = listaRutasDeAcceso?.find(r => r.codigo_programa === CONST_CODIGO_MODULOS_AGREGAR)
    const encontradoRutaBotonEditar = listaRutasDeAcceso?.find(r => r.codigo_programa === CONST_CODIGO_MODULOS_EDITAR)
    const encontradoRutaBotonEliminar = listaRutasDeAcceso?.find(r => r.codigo_programa === CONST_CODIGO_MODULOS_ELIMINAR)

    encontradoRutaBotonAgregar ? setMostrarBotonAgregar(true) : setMostrarBotonAgregar(false)
    encontradoRutaBotonEditar ? setMostrarBotonEditar(true) : setMostrarBotonEditar(false)
    encontradoRutaBotonEliminar ? setMostrarBotonEliminar(true) : setMostrarBotonEliminar(false)

  }, [listaRutasDeAcceso])

  useEffect(() => {

    const cargarDatosIniciales = async () => {
      await obtenerCompaniasYSucursales()
      await modulosBuscarTodos()
    };

    cargarDatosIniciales();
    // carga inicial (una sola vez al montar)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Al cerrar el modal (agregar/editar) se refresca el listado montado de fondo.
  useRefetchAlCerrarModal(CONST_RUTA_MODULOS_LISTAR, modulosBuscarTodos)

  return (
    <div className="p-3">
      <div className="container-fluid">
        <h3 className="tw-text-center tw-text-2xl tw-font-semibold tw-text-menu-primario tw-mt-1 tw-mb-4">Módulos</h3>

        {/* Formulario */}
        <div className="tw-mb-4 tw-rounded-2xl tw-bg-white tw-p-4 tw-shadow-md tw-border tw-border-gray-100">
          <form onSubmit={handleSubmit(onSubmitBuscar)} className="row g-2">

            <div className="col-12 col-lg-6">
              <label className="text-start tw-text-xs tw-font-semibold tw-text-gray-600 tw-mb-1 tw-block">Compañía</label>
              <select
                {...register("compania",{
                  required: true
                })}
                className="form-select form-select-sm"
                value={watch("compania")}
              >
                {
                  listaCompanias?.length > 0 && listaCompanias.map(e => (
                    <option key={e?.id} value={e?.id}>{e?.tipo}</option>
                  ))
                }
              </select>
            </div>
            <div className="col-12 col-lg-5">
              <label className="text-start tw-text-xs tw-font-semibold tw-text-gray-600 tw-mb-1 tw-block">Estado</label>
              <select {...register("estado")} className="form-select form-select-sm">
                {
                  listaEstadosActivoBusqueda?.length > 0 && listaEstadosActivoBusqueda.map(e => (
                    <option
                      key={e?.id}
                      value={e?.id}
                    >{e?.tipo}</option>
                  ))
                }
              </select>
            </div>
            <div className="col-12 col-lg-1">
              <label className="text-start tw-text-xs tw-font-semibold tw-text-gray-600 tw-mb-1 tw-block">&nbsp;</label>
              <div className={isMobile ? "text-center" : ""}>
                <button type="submit" onClick={handleSubmit(onSubmitBuscar)} style={{ cursor: 'pointer', background: 'none', border: 'none' }}>
                  <BiSearch size={25} className="color-iconos" />
                </button>
              </div>
            </div>
          </form>
        </div>
        {/* Fin formulario */}

        <div className="mx-auto ps-0">
          <div className={mostrarBotonAgregar ? "d-flex justify-content-between" : "d-flex justify-content-end"}>
            {
              mostrarBotonAgregar && (
                <div>
                  <button className='btn btn-primario btn-sm me-5' onClick={moduloAgregar}>
                    <div className="d-flex align-items-center"> {/* Contenedor para centrar */}
                      <IoMdAdd size={18} />
                      <span className="ms-1">Agregar</span>
                    </div>
                  </button>
                  {/* <button className='btn btn-primario btn-sm' onClick={handleSubmitOrdenar(moduloOrdenar)}>
                    <div className="d-flex align-items-center">
                      <BsSortNumericDown />
                      <span className="ms-1">Ordenar</span>
                    </div>
                  </button> */}
                </div>
              )}

            <div>
              <button className="btn btn-light btn-sm" onClick={moduloRetroceder} style={{ cursor: 'pointer' }}><LuArrowUpNarrowWide size={25} className="color-iconos" /></button>
            </div>
          </div>
        </div>



        {/* Tabla de resultados */}
        <ModulosTabla
          isLoading={isLoading}
          listaModulos={listaModulos}
          buscar={buscar}
          mostrarBotonEditar={mostrarBotonEditar}
          mostrarBotonEliminar={mostrarBotonEliminar}
          moduloListarSubModulos={moduloListarSubModulos}
          moduloEditar={moduloEditar}
          moduloEliminar={moduloEliminar}
        />
        {/* Fin Tabla de resultados */}

      </div>
    </div>
  )
}
